import { defineComponent as _defineComponent } from 'vue'

import { ClientMissionLifecycleFragmentFragment } from "@/gql"
import TeamMemberCard from "@/modules/Missions/components/TeamMemberCard/TeamMemberCard.vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'TeamMembersPrintable',
  props: {
    mission: null
  },
  setup(__props: any) {



return { __sfc: true,TeamMemberCard }
}

})